import { createFeatureSelector, createSelector } from '@ngrx/store';
import { RequestsTypeFeatureKey } from './requests-type-feature-key';
import { RequestsTypeState } from './requests-type.state';

export const RequestsTypeFeatureSelector =
  createFeatureSelector<RequestsTypeState>(RequestsTypeFeatureKey);
// All RequestsType
export const allRequestsTypeSelector = createSelector(
  RequestsTypeFeatureSelector,
  (state) => {
    return state.allRequestsType;
  }
);
// Create RequestsType
export const createRequestTypeSelector = createSelector(
  RequestsTypeFeatureSelector,
  (state) => {
    return state.createRequestType;
  }
);
// Delete RequestsType
export const deleteRequestTypeSelector = createSelector(
  RequestsTypeFeatureSelector,
  (state) => {
    return state.deleteRequestType;
  }
);
// Update RequestsType
export const updateRequestTypeSelector = createSelector(
  RequestsTypeFeatureSelector,
  (state) => {
    return state.deleteRequestType;
  }
);
// Update RequestsType
export const requestActionsByCompanySelector = createSelector(
  RequestsTypeFeatureSelector,
  (state) => {
    return state.requestActionsByCompany;
  }
);

/**
 * All RequestsType Selector
 */
export const allRequestsTypeSuccessSelector = createSelector(
  allRequestsTypeSelector,
  (state) => {
    return state.data;
  }
);
export const allRequestsTypeFailureSelector = createSelector(
  allRequestsTypeSelector,
  (state) => {
    return state.failure;
  }
);
export const allRequestsTypeLoadingSelector = createSelector(
  allRequestsTypeSelector,
  (state) => {
    return state.loading;
  }
);

/**
 * Create RequestsType Selector
 */
export const createRequestTypeSuccessSelector = createSelector(
  createRequestTypeSelector,
  (state) => {
    return state.data;
  }
);
export const createRequestTypeFailureSelector = createSelector(
  createRequestTypeSelector,
  (state) => {
    return state.failure;
  }
);
export const createRequestTypeLoadingSelector = createSelector(
  createRequestTypeSelector,
  (state) => {
    return state.loading;
  }
);
/**
 * Delete RequestsType Selector
 */
export const deleteRequestTypeSuccessSelector = createSelector(
  deleteRequestTypeSelector,
  (state) => {
    return state.data;
  }
);
export const deleteRequestTypeFailureSelector = createSelector(
  deleteRequestTypeSelector,
  (state) => {
    return state.failure;
  }
);
export const deleteRequestTypeLoadingSelector = createSelector(
  deleteRequestTypeSelector,
  (state) => {
    return state.loading;
  }
);

/**
 * Update RequestsType Selector
 */
export const updateRequestTypeSuccessSelector = createSelector(
  updateRequestTypeSelector,
  (state) => {
    return state.data;
  }
);
export const updateRequestTypeFailureSelector = createSelector(
  updateRequestTypeSelector,
  (state) => {
    return state.failure;
  }
);
export const updateRequestTypeLoadingSelector = createSelector(
  updateRequestTypeSelector,
  (state) => {
    return state.loading;
  }
);
/**
 * Request Actions By Company Selector
 */
export const requestActionsByCompanySuccessSelector = createSelector(
  requestActionsByCompanySelector,
  (state) => {
    return state.data;
  }
);
export const requestActionsByCompanyFailureSelector = createSelector(
  requestActionsByCompanySelector,
  (state) => {
    return state.failure;
  }
);
export const requestActionsByCompanyLoadingSelector = createSelector(
  requestActionsByCompanySelector,
  (state) => {
    return state.loading;
  }
);
/**
 * Change Request Action Type
 */

export const changeRequestActionTypeSelector = createSelector(
  RequestsTypeFeatureSelector,
  (state) => {
    return state.changeRequestActionType;
  }
);
export const changeRequestActionTypeSuccessSelector = createSelector(
  changeRequestActionTypeSelector,
  (state) => {
    return state.data;
  }
);
export const changeRequestActionTypeFailureSelector = createSelector(
  changeRequestActionTypeSelector,
  (state) => {
    return state.failure;
  }
);
export const changeRequestActionTypeLoadingSelector = createSelector(
  changeRequestActionTypeSelector,
  (state) => {
    return state.loading;
  }
);
